import DialogContentText from '@material-ui/core/DialogContentText';

/** @deprecated  Exporting the DialogContentText component from the material-ui library. */
export default DialogContentText;
